import TopNav from "../../navbars/topNav/topNav";
import "./webLayout.scss";

export default function WebLayout(props: {
  children?: any;
  pageIndex?: number;
}) {
  return (
    <div className="layout">
      <TopNav index={props.pageIndex} />
      <div className="children">{props.children}</div>
    </div>
  );
}
